(function () {
    'use strict';

    angular
        .module('app.addPostToProject')
        .controller('addPostToProjectCtrl', ['$scope', '$modal', '$http', '$rootScope', '$modalInstance', 'advertisersManagementService', 'addPostToProjectService',
            function ($scope, $modal, $http, $rootScope, $modalInstance, advertisersManagementService, addPostToProjectService)
            {
                $scope.currentUser = $rootScope.currentUser;              
                $scope.countProjectAdd = 0;

                $scope.getdata = function ()
                {
                    if($scope.currentUser.role.accessLevel == 'admin'){
                        var url = $rootScope.apiUrl + 'admin/GetAllAdvertiser';
                        $http.get(url, {loader: false}).
                            success(function (response) {
                                $scope.advertisers = response.data;
                                $scope.advertisers[0].ticked = true;
                                $scope.selectedAdvertiserId = $scope.advertisers[0].id;
                                $scope.getProjectList($scope.advertisers[0].id, true);
                            }).error(function (response) {
                                $scope.advertisers = [];
                            });
                    } 

                    if($scope.currentUser.role.accessLevel == 'agency') {
                        var url = $rootScope.apiUrl + 'common/getGoverningAgencyByAgency/' + $scope.currentUser.company.id;
                        $http.get(url, {loader: false}).
                            success(function (response) {
                                $scope.advertisers = response.data;
                                $scope.advertisers[0].ticked = true;
                                $scope.selectedAdvertiserId = $scope.advertisers[0].id;
                                $scope.getProjectList($scope.advertisers[0].id, true);
                            }).error(function (response) {
                                $scope.advertisers = [];
                            });
                    }
                    
                    if($scope.currentUser.role.accessLevel == 'advertiser')
                    {
                        $scope.getProjectList($scope.currentUser.company.id, true);
                        $scope.selectedAdvertiserId = $scope.currentUser.company.id;
                    }
                }

                $scope.getProjectList = function(advertiserID, loader)
                {
                    $scope.countProjectAdd = 0;
                    addPostToProjectService.getAllProjectByAdvertiserID(advertiserID, loader)
                        .then(function(result){
                            $scope.projects = result.data;
                            addPostToProjectService.getListProjectAddPost(advertiserID, $scope.postUrlHash, loader)
                                .then(function(resultListProjectAddPost){
                                    $scope.listProjectAddPost = resultListProjectAddPost.data;
                                    angular.forEach($scope.projects, function(item){
                                        item.ticked = false;
                                    })
                                    angular.forEach($scope.projects, function(item){
                                        angular.forEach($scope.listProjectAddPost, function(projectAddPost){
                                            if(item.id == projectAddPost.projectId){
                                                item.ticked = true;
                                                item.status = projectAddPost.status === 0? 'pending' : 'added';
                                                item.isAddedManually = projectAddPost.isAddedManually;    
                                                $scope.countProjectAdd = $scope.countProjectAdd + 1;
                                            }
                                        })
                                    })

                                })
                                .catch(function(message){
                                })
                                .finally(function(){
                                });
                        })
                        .catch(function(message){
                        })
                        .finally(function(){
                        });
                }

                $scope.selectAdvertiser = function(advertiser)
                {
                    angular.forEach($scope.advertisers, function(item){
                        item.ticked = false;
                        if(advertiser.id == item.id) {
                            item.ticked = true;
                            $scope.selectedAdvertiserId = advertiser.id;
                        }
                    })
                    $scope.getProjectList(advertiser.id, true);

                }

                $scope.selectProject = function(project) {
                    if (project.ticked && project.isAddedManually === false) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=07292016',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = "You can currently only remove posts that were manually added to a project. This limit will be resolved in the near future.";
                        return;
                    }
                    $scope.countProjectAdd = 0;
                    angular.forEach($scope.projects, function(item) {
                        if(project.id == item.id)
                        {
                            if(item.ticked)
                            {
                                item.ticked = false;
                            }
                            else
                            {
                                item.ticked = true;
                            }
                        }
                    })
                    angular.forEach($scope.projects, function(item) {
                        if(item.ticked) {
                            $scope.countProjectAdd = $scope.countProjectAdd + 1;
                        }
                    })
                }

                $scope.saveProject = function() {
                    var addedList =[],
                        removedList = [],
                        addedPrjNameList = '',
                        removedPrjNameList = '',
                        firstAddedPrjItem = true,
                        firstRemovedPrjItem = true;
                    angular.forEach($scope.projects, function(item) {
                        if(item.ticked) {
                            var isNewAddedPrj = true;
                            for (var i=0; i<$scope.listProjectAddPost.length; i++) {
                                if ($scope.listProjectAddPost[i].projectId === item.id) {
                                    isNewAddedPrj = false;
                                    break;
                                }
                            }
                            if (isNewAddedPrj) {
                                var params = {
                                    projectId: item.id,
                                    companyId: $scope.selectedAdvertiserId,
                                    postUrlHash: $scope.postUrlHash,
                                    postRelativePath: $scope.postRelativePath
                                }
                                addedList.push(params);
                                var prefix = firstAddedPrjItem? ' ': ', ';
                                addedPrjNameList = addedPrjNameList + prefix + item.name; 
                                firstAddedPrjItem = false;
                            }
                        }
                        else {
                            for (var i=0; i<$scope.listProjectAddPost.length; i++) {
                                if ($scope.listProjectAddPost[i].projectId === item.id) {
                                    removedList.push($scope.listProjectAddPost[i].id);
                                    var prefix = firstRemovedPrjItem? ' ': ', ';
                                    removedPrjNameList = removedPrjNameList + prefix + item.name; 
                                    firstRemovedPrjItem = false;
                                    break;
                                }
                            }
                        }
                    })
                    if (addedList.length > 0) {
                        $scope.addPostToProject(addedList, addedPrjNameList);
                    }
                    if (removedList.length > 0) {
                        $scope.removePostToProject(removedList, removedPrjNameList);
                    }

                    if (addedList.length > 0 || removedList.length > 0) {
                        //$scope.getProjectList($scope.selectedAdvertiserId, false);
                        addPostToProjectService.getListProjectAddPost($scope.selectedAdvertiserId, $scope.postUrlHash, false)
                            .then(function(resultListProjectAddPost){
                                $scope.listProjectAddPost = resultListProjectAddPost.data;
                            });
                    };
                }

                $scope.addPostToProject = function(params, prjName)
                {
                    var data = {projects: params};
                    addPostToProjectService.addPostToProject(data, true)
                        .then(function(result){
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/successMessageBox.html?app_v=deployDate'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = "The post has been added to " + prjName + " successfully, and we're collecting data on it now. Please allow up to 48 hours for it to be visible in your project feed and included in your project's KPI numbers.";
                        })
                        .catch(function(message){
                        })
                        .finally(function(){
                        });
                }
                $scope.removePostToProject = function(params, prjName)
                {
                    var data = {projects: params};
                    addPostToProjectService.removeAddPostToProject(data, false)
                        .then(function(result){
                            var msg = "This post has been marked for deletion. It’ll be removed from the " + prjName + " within the next 48 hours.";
                            var errorModalInstance = $modal.open({
                                templateUrl: 'app/common/partials/messageBox.html?app_v=deployDate',
                                controller: [
                                    '$scope',
                                    '$modalInstance',
                                    function ($scope, $modalInstance) {
                                        var modalVm = this;
                                        var closeModal = function () {
                                            $modalInstance.dismiss('cancel');
                                        };
                                        modalVm.msg = msg;
                                        modalVm.closeModal = closeModal;
                                    }
                                ],
                                controllerAs: 'modalVm'
                            });
                        })
                        .catch(function(message){
                        })
                        .finally(function(){
                        });
                }

                $scope.closeModal = function()
                {
                    $modalInstance.close();
                }

                $scope.getdata();
            }
        ]);
})();
